// import { useState, useEffect } from 'react';
import { Image } from 'react-bootstrap';
import { images } from '../../resource/media';

function MediaTable() {
  const Thumbnail = (props) => {
    const url = require(`../../assets/images/media/${props.image}`);

    return (
      <a href={url.default} target="_blank" rel="noreferrer">
        <Image
          className="media__table-image"
          src={url.default}
          alt={props.image}
          thumbnail
        />
      </a>
    );
  };

  return (
    <div className="media__table-container">
      <div className="media__table-wrapper">
        {images.map((image) => (
          <div className="media__table-item">
            <Thumbnail image={image} key={image} />
          </div>
        ))}
      </div>
    </div>
  );
}
export default MediaTable;
